export const LOCATION = 'restaurantLocations';
export const LOCATION_SEARCH = 'locationSearch';
export const LOCATION_DETAIL = 'locationDetail';
export const LOCATION_INVENTORY = 'locationInventory';
export const LOCATION_THROTTLED_TIMES = 'locationThrottledTimes';
